// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"failed-printers_wrapper__sB0mw","wrapper-ltr":"failed-printers_wrapper-ltr__1Gxd7"};